<div class="template-wrapper">
  <div class="report-config">
    <div class="title">
      <div>Schedule Report</div>
      <button class="close-button" (click)="activeModal.close()">
        <rkt-icon name="times"></rkt-icon>
      </button>
    </div>
    <div class="report-config-form">
      <div class="form-details">
        <div class="section-title">
          <div class="section-title-text">Report Type</div>
        </div>

        <div class="section-content">
          @if (reportTemplates?.length) {
            @for (reportTemplate of reportTemplates; track reportTemplate) {
              <div
                class="report-template-list-item"
                (click)="setSelectedTemplate(reportTemplate)"
                [class.active]="selectedTemplate === reportTemplate"
              >
                {{ reportTemplate.name }}
              </div>
            }
          } @else {
            @if (!isLoading) {
              <div class="empty-state">
                <div class="image"></div>
                <div class="message">No Template Available</div>
              </div>
            }
            @if (isLoading) {
              <div class="section-content">
                @for (i of [].constructor(3); track i) {
                  <div class="report-template-list-item"></div>
                }
              </div>
            }
          }
        </div>

        <div class="section-title">
          <div class="section-title-text">Scheduling</div>
        </div>

        <div class="section-content">
          <form [formGroup]="createScheduleReportForm">
            <rkt-form [form]="createScheduleReportForm" [fields]="reportFormFields" [model]="addReportModel"></rkt-form>
          </form>
        </div>
      </div>

      <div class="form-footer">
        <div class="details-page-edit-form-error">{{ submitError }}</div>

        <div class="buttons">
          <button
            rktButton
            type="submit"
            (click)="onSave()"
            [disabled]="isLoading || createScheduleReportForm.invalid || !selectedTemplate"
          >
            Schedule
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="report-preview">
    @if (selectedTemplate && selectedTemplate.previewSignedUrl) {
      <app-view-pdf-document
        [documentName]="selectedTemplate.name"
        [documentURL]="selectedTemplate.previewSignedUrl"
        [containerHeight]="'41.5rem'"
        [showDownloadButton]="false"
        [showPrintButton]="false"
        [showModalHeader]="false"
      ></app-view-pdf-document>
    } @else {
      <div class="empty-state">
        <div class="image"></div>
        <div class="message">No preview available</div>
      </div>
    }
  </div>
</div>
